import { render, staticRenderFns } from "./AdminAddNewOffice.vue?vue&type=template&id=51be294e&scoped=true"
import script from "./AdminAddNewOffice.vue?vue&type=script&lang=js"
export * from "./AdminAddNewOffice.vue?vue&type=script&lang=js"
import style0 from "./AdminAddNewOffice.vue?vue&type=style&index=0&id=51be294e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be294e",
  null
  
)

export default component.exports